import React, { Component } from "react";
import { View, ScrollView, Image, SafeAreaView, StyleSheet, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import styles from "../../shared/styles";
import Actions from "../../actions";
import { global } from "../../utils";
import { error_ic, success_ic } from "../../assets";
import { Label, Form } from "../../components/SharedComponents";
import Header from "../../shared/components/Header";
import { LinkBlue, ContainerDesc, LinkAlert, Touchable, RegistrationProgress, InputFiled, SignupPasswordField } from "../../shared/components";
import localize from "../../shared/localize";
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

class CreateAccount extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            errorMessage: null,
            validUsername: [],
            password: "",
            status: false,
            passwordError: localize.Must_be_a_minimum_of_8_characters_and_hard_for_robots_to_guess,
            fb_id: "",
            security_email: "",
            loginType: "basic"     // "basic", "fb"
        }
    }

    _navigate = (pathname, state, search) => {
        if (!global.isNative) {
            return this.props.history.push({
                pathname: '/' + pathname,
                state,
                search
            });
        }
        return this.props.navigation.navigate(pathname, state)
    };
    onUsernameChange = async (username) => {
        this.setState({ status: true });
        this.setState({ username });
        let response = await this.props.checkUsername(username);
        this.setState({ errorMessage: response.message, validUsername: response.validUsername })
    }

    onPasswordChange = async (password, progressUpdate) => {
        this.setState({ status: true });
        this.setState({ password, passwordError: this.state.passwordError });
        let response = await this.props.passwordValidate(password);
        this.setState({ passwordError: response.message })
        progressUpdate(response.progress);
    }

    onRegister = async () => {
        // const { username, password } = this.state;
        // this.props.updateAuthState({ registerUser: { username, password } })
        // this._navigate(global.isNative ? "AccountSecurity" : "Account-Security")
        try {
            const { username, password, fb_id, security_email, loginType } = this.state;
            let registerUser = {
                username,
                password
            }
            if (loginType === "fb") {
                registerUser = { ...registerUser, fb_id, security_email };
                this.props.updateAuthState({ registerUser });

                let result = await this.props.userRegister(registerUser);
                if (result.status === 200 || result.status === 201) {
                    return this.props.history.push({ pathname: "Signup-Success" });
                }
                return this.setState({ errorMessage: result.message });

            } else {
                this.props.updateAuthState({ registerUser });
                this._navigate("Account-Security")
            }
        } catch (error) {
            console.log(error);
        }
    }

    render() {
        const { validUsername, username, errorMessage, password, passwordError, loginType } = this.state;
        return (
            <SafeAreaView styles={styles.container}>
                {!global.isNative && (<Header title={localize.Create_Account} goBack={() => this.props.history.goBack()} />)}
                <ScrollView style={{ height: this.props.height - 70 }}>
                    <RegistrationProgress progress={1} />
                    <View style={{ paddingHorizontal: 20 }}>
                        <Label.PrimaryTitle>
                            {localize.This_is_the_login_you_will_use_to_sign_into_AmericaU}
                        </Label.PrimaryTitle>
                        {
                            loginType === "basic" && (
                                <>
                                    <View style={{ height: 30 }} />
                                    <Label.PrimaryTitle align='center' size={16}>
                                        {localize.Sign_Up_Via_Facebook}
                                    </Label.PrimaryTitle>
                                    <View style={{ height: 15 }} />
                                    <View style={{ flex: 1, alignItems: "center" }}>
                                        <FacebookLogin
                                            appId="1311658175556089"
                                            autoLoad={false}
                                            publishPermissions={['publish_actions']}
                                            readPermissions={['public_profile']}
                                            fields="email, id"
                                            callback={this.facebookLogin}
                                            render={renderProps => (
                                                <Form.Button
                                                    title={localize.facebook}
                                                    size='small'
                                                    onPress={renderProps.onClick}
                                                />
                                            )}
                                        />
                                    </View>
                                    <View style={{ height: 15 }} />
                                    <Label.PrimaryTitle align='center' size={16}>
                                        {localize.Or_Fill_the_form_given_below}
                                    </Label.PrimaryTitle>
                                </>
                            )
                        }

                        <View style={{ paddingTop: 40 }}>

                            <InputFiled
                                placeholder={localize.create_user_name}
                                value={username}
                                onChange={this.onUsernameChange}
                                style={errorMessage !== null ? styles.borderAlert : username !== '' ? styles.borderGreen : styles.borderGrey}
                                lable={localize.user_name}
                                errorMessage={errorMessage}
                                rightComponent={
                                    errorMessage !== null ?
                                        <Image source={error_ic} style={pageStyles.inputIcon} />
                                        : username !== '' ?
                                            <Image source={success_ic} style={pageStyles.inputIcon} />
                                            : null
                                }
                            />

                            <View style={pageStyles.rowUser}>
                                {
                                    validUsername.map((username, i) =>
                                        <Touchable
                                            key={i.toString()}
                                            component={(<LinkAlert title={i === validUsername.length - 1 ? username : username + ', '} />)}
                                            onPress={() => this.setState({ username, errorMessage: null, validUsername: [] })}
                                            style={{ alignSelf: 'baseline' }}
                                        />
                                    )
                                }
                            </View>
                        </View>
                    </View>

                    <SignupPasswordField
                        status={this.state.status}
                        lable={localize.password}
                        placeholder={localize.longer_is_stronger}
                        onChange={this.onPasswordChange}
                        value={password}
                        passwordError={passwordError}
                    />

                    <View style={{ margin: 20, top: 20 }}>
                        <Form.Button
                            title={localize.Next}
                            disabled={this.handleButtonDisable()}
                            onPress={this.onRegister}
                        />
                    </View>

                    <TouchableOpacity
                        style={pageStyles.link}
                        onPress={() => this.props.navigation.push("SignIn")}
                    >
                        <Label.LinkIndigo>
                            {localize.Sign_in_to_existing_account}
                        </Label.LinkIndigo>
                    </TouchableOpacity>

                </ScrollView>
            </SafeAreaView>
        );
    }

    handleButtonDisable = () => {
        const { errorMessage, passwordError, username, password } = this.state;
        if (errorMessage === null && passwordError === null) {
            if (username === '' || password === '') {
                return true;
            }
            return false;
        }
        return true
    }

    facebookLogin = async (resp) => {
        console.log(resp);
        const { email, id } = resp;
        this.setState({
            fb_id: id,
            security_email: email,
            loginType: 'fb'
        })
    }

}

const mapStateToProps = ({ setting }) => {
    return {
        height: setting.height
    }
}

const mapDispatch = (dispatch) => {
    return {
        updateAuthState: request => dispatch(Actions.updateAuthState(request)),
        userRegister: request => dispatch(Actions.userRegister(request)),
        passwordValidate: request => Actions.passwordValidate(request),
        checkUsername: request => Actions.checkUsername(request),
    }
}
export default connect(mapStateToProps, mapDispatch)(CreateAccount);

const pageStyles = StyleSheet.create({
    inputIcon: {
        height: 18,
        width: 18,
        resizeMode: "contain"
    },
    rowUser: {
        flexDirection: 'row',
        flex: 1,
        flexWrap: 'wrap',
        paddingBottom: 5
    },
    link: {
        alignSelf: "center",
        marginVertical: 30,
        marginHorizontal: 20
    }
})